var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ant-message",style:({ top: _vm.top + 'px' })},[_c('span',_vm._l((_vm.notices),function(notice){return _c('notice',{key:notice.selfKey,attrs:{"content":notice.content,"duration":notice.duration,"selfKey":notice.selfKey,"type":notice.type,"on-close":notice.onClose},on:{"close":_vm.close}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92abf63a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./vb/components/message/message.vue
// module id = null
// module chunks = 